export default __webpack_public_path__ + "static/media/web-development.ad20eda6.gif";